import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { useTranslation } from 'react-i18next'

export default function RaceVenueInfo () {
  const { t } = useTranslation('raceGuide')
  return (
    <Box>
      {/* Race Venue/Finish Section */}
      <Grid container spacing={3} sx={{ marginBottom: 4 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card elevation={3}>
            <CardMedia
              component='img'
              image='https://d1hi0tbu2kom2c.cloudfront.net/img/race-village-1.png'
              alt={t('raceVenue.venueAlt1')}
            />
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Typography variant='h6'>
                {t('raceVenue.venueFinish')}
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary={t('raceVenue.startFinish')} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={t('raceVenue.spectator')} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={t('raceVenue.shuttlePoints')} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={t('raceVenue.parking')} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={t('raceVenue.toilets')} />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Location Section */}
      <Card>
        <CardContent>
          <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
            {t('raceVenue.locationLabel')} <Typography component='span'>Jabel Jais</Typography>
          </Typography>
          <Typography variant='body1' sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
            {t('raceVenue.securityGate')}
          </Typography>
        </CardContent>

      </Card>

      {/* Race Venue Details Section */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card elevation={3}>
            <CardMedia
              component='img'
              image='https://d1hi0tbu2kom2c.cloudfront.net/img/race-village-2.png'
              alt={t('raceVenue.venueAlt2')}
            />
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Typography variant='h6'>
                {t('raceVenue.venue')}
              </Typography>

              <List dense>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.bibCollection')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.kitDistribution')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.kitCheck')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.entertainment')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.partnersSponsors')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.mainStage')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.finishersArea')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.medicalArea')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.foodVendors')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('raceVenue.sportsVendors')}
                    primaryTypographyProps={{ fontSize: '1rem', fontWeight: 500 }}
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
